import { render } from "./NewApplicationList.vue?vue&type=template&id=ec145484&scoped=true"
import script from "./NewApplicationList.vue?vue&type=script&lang=js"
export * from "./NewApplicationList.vue?vue&type=script&lang=js"

import "./NewApplicationList.vue?vue&type=style&index=0&id=ec145484&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec145484"]])

export default __exports__